import React from "react";

const TermsOfService = () => (
  <div
    style={{
      maxWidth: "800px",
      margin: "0 auto",
      padding: "24px 16px 40px",
      lineHeight: 1.6,
      fontSize: "0.95rem",
      textAlign: "left",
    }}
  >
    <h2 style={{ marginTop: 0, marginBottom: "16px", fontSize: "1.6rem" }}>
      Terms of Service
    </h2>

    <p style={{ marginBottom: "24px", color: "#555" }}>
      <strong>Effective:</strong> November 2025
    </p>

    <p style={{ marginBottom: "16px" }}>
      Welcome to PriorityPop! By accessing or using our site or application, you
      agree to the following terms. Please read them carefully.
    </p>

    <section style={{ marginBottom: "24px" }}>
      <h3 style={{ marginBottom: "8px", fontSize: "1.15rem" }}>
        1. Eligibility
      </h3>
      <p style={{ margin: 0 }}>
        You must be at least 13 years old to use PriorityPop. By using the
        service, you confirm that you meet this requirement.
      </p>
    </section>

    <section style={{ marginBottom: "24px" }}>
      <h3 style={{ marginBottom: "8px", fontSize: "1.15rem" }}>
        2. Use of the Service
      </h3>
      <ul style={{ paddingLeft: "1.25rem", margin: 0, listStyleType: "disc" }}>
        <li style={{ marginBottom: "6px" }}>
          You agree to use PriorityPop only for lawful purposes.
        </li>
        <li style={{ marginBottom: "6px" }}>
          You retain ownership of the content you enter into the app, but grant
          us a license to use it for operating, maintaining, improving, and
          analyzing the service.
        </li>
        <li>
          We may update or modify the service at any time, including adding or
          removing features.
        </li>
      </ul>
    </section>

    <section style={{ marginBottom: "24px" }}>
      <h3 style={{ marginBottom: "8px", fontSize: "1.15rem" }}>
        3. Data &amp; Analysis
      </h3>
      <ul style={{ paddingLeft: "1.25rem", margin: 0, listStyleType: "disc" }}>
        <li style={{ marginBottom: "6px" }}>
          <strong>
            We do not sell or share your individual data with third parties.
          </strong>
        </li>
        <li style={{ marginBottom: "6px" }}>
          We may analyze your data internally and combine it with anonymized,
          aggregated data from other users to provide AI-driven insights and
          performance comparisons.
        </li>
      </ul>
    </section>

    <section style={{ marginBottom: "24px" }}>
      <h3 style={{ marginBottom: "8px", fontSize: "1.15rem" }}>4. Accounts</h3>
      <ul style={{ paddingLeft: "1.25rem", margin: 0, listStyleType: "disc" }}>
        <li style={{ marginBottom: "6px" }}>
          You are responsible for keeping your login credentials secure.
        </li>
        <li>
          We may temporarily suspend or permanently terminate your account if
          you violate these Terms.
        </li>
      </ul>
    </section>

    <section style={{ marginBottom: "24px" }}>
      <h3 style={{ marginBottom: "8px", fontSize: "1.15rem" }}>
        5. Disclaimers
      </h3>
      <p style={{ margin: 0 }}>
        PriorityPop is provided “as is” and without warranties of any kind. We
        do not guarantee uninterrupted availability, error-free performance, or
        any particular productivity outcomes.
      </p>
    </section>

    <section style={{ marginBottom: "24px" }}>
      <h3 style={{ marginBottom: "8px", fontSize: "1.15rem" }}>
        6. Limitation of Liability
      </h3>
      <p style={{ margin: 0 }}>
        To the fullest extent permitted by law, PriorityPop is not liable for
        any indirect, incidental, special, consequential, or punitive damages
        arising from your use of the service.
      </p>
    </section>

    <section style={{ marginBottom: "24px" }}>
      <h3 style={{ marginBottom: "8px", fontSize: "1.15rem" }}>
        7. Termination
      </h3>
      <p style={{ margin: 0 }}>
        You may stop using the service at any time. We may suspend or terminate
        your access if you breach these Terms or misuse the service.
      </p>
    </section>

    <section style={{ marginBottom: "8px" }}>
      <h3 style={{ marginBottom: "8px", fontSize: "1.15rem" }}>
        8. Governing Law
      </h3>
      <p style={{ margin: 0 }}>
        These Terms are governed by the laws of the United States. Any disputes
        shall be resolved under the jurisdiction of the appropriate U.S. courts.
      </p>
    </section>
  </div>
);

export default TermsOfService;
